export const RECYCLE_SOURCE_OPTIONS = [
  {
    label: 'Internal Post-Industrial Waste (e.g., recycled manufacturing scrap materials within facilities)',
    value: 'Internal Post-Industrial Waste (e.g., recycled manufacturing scrap materials within facilities)',
    id: 'internal-post-industrial'
  },
  {
    label: 'External AP/FW Post-Industrial Waste (e.g., recycled manufacturing scrap from other facilities)',
    value: 'External AP/FW Post-Industrial Waste (e.g., recycled manufacturing scrap from other facilities)',
    id: 'external-ap-fw-post-industrial'
  },
  {
    label: 'External non-AP/FW Post-Industrial Waste (e.g., synthetic fiber from non-AP textiles)',
    value: 'External non-AP/FW Post-Industrial Waste (e.g., synthetic fiber from non-AP textiles)',
    id: 'external-non-ap-fw-post-industrial'
  },
  {
    label: 'Single-Stream Post-Consumer – PET bottle flake',
    value: 'Single-Stream Post-Consumer – PET bottle flake',
    id: 'single-stream-post-consumer-food-grade'
  },
  {
    label: 'Single-Stream Post-Consumer – garment takeback (e.g., textile-to-textile)',
    value: 'Single-Stream Post-Consumer – garment takeback (e.g., textile-to-textile)',
    id: 'single-stream-post-consumer-other'
  },
  {
    label: 'Mixed-Stream Post-Consumer Waste',
    value: 'Mixed-Stream Post-Consumer Waste',
    id: 'mixed-source-post-consumer-waste'
  },
  {
    label: 'Unknown',
    value: 'Unknown',
    id: 'unknown-recycle-source'
  }
];

export const RECYCLE_METHOD_OPTIONS = [
  {
    label: 'Mechanical Recycling (including thermo-mechanical recycling)',
    value: 'Mechanical Recycling (including thermo-mechanical recycling)',
    id: 'mechanical-recycling'
  },
  {
    label: 'Chemical Recycling (e.g., pyrolysis, glycolysis, acidolysis, methanolysis)',
    value: 'Chemical Recycling (e.g., pyrolysis, glycolysis, acidolysis, methanolysis)',
    id: 'chemical-recycling'
  },
  {
    label: 'Other Advanced Recycling (e.g., enzymatic)',
    value: 'Other Advanced Recycling (e.g., enzymatic)',
    id: 'advanced-recycling'
  },
  {
    label: 'Unknown',
    value: 'Unknown',
    id: 'unknown-recycle-method'
  }
];

export const RECYCLE_SOURCE_QUESTION_NEW = 'What is the source of this recycling stream and feedstock?';
export const RECYCLE_SOURCE_QUESTION_LEGACY = 'List the samples recycled material source (e.g. post industrial, post consumer, pre consumer, etc.)';
export const RECYCLE_SOURCE_QUESTION_LEGACY_SHORT = 'List the samples recycled material source';
export const RECYCLE_METHOD_QUESTION = 'What is the method of recycling?';
export const RECYCLE_DESCRIPTION_QUESTION = 'Describe the recycled content in the material sample';
export const RECYCLE_DESCRIPTION_QUESTION_WITH_EXAMPLE = 'Describe the recycled content in the material sample (e.g. 20% recycled PET, 10% recycled TPU, etc.)';

const isOptionValue = (value, options) => options.some(option => option.value === value);

export const hasLegacyRecycleAnswers = (sourceValue) => {
  const source = (sourceValue || '').trim();
  // Legacy flow should be shown only when old source data already exists.
  // If source is empty in edit mode, we show the new dropdown flow.
  return !!source && !isOptionValue(source, RECYCLE_SOURCE_OPTIONS);
};

export const getRecycleSourceQuestion = ({ sourceValue, recycleMethod }) => {
  const normalizedSource = (sourceValue || '').toString().trim();
  const hasRecycleMethod = !!(recycleMethod && recycleMethod.toString().trim() !== '');
  const isNewRecycleSource = RECYCLE_SOURCE_OPTIONS
    .map(option => option.value.trim())
    .includes(normalizedSource);

  return hasRecycleMethod || isNewRecycleSource || !hasLegacyRecycleAnswers(normalizedSource)
    ? RECYCLE_SOURCE_QUESTION_NEW
    : RECYCLE_SOURCE_QUESTION_LEGACY;
};
